export default {
    data () {
        return {
            invalidChars : [
                "e",
                "E",
                "i",
                "-"
            ]
        }
    },

    methods : {
        /**
         * Stop E/e entry and other number validation checks on Event
         * Will block Event if validation throws error
         *
         * @param e         $event
         * @param onlyIf    Boolean Only execute check if condition is true
         */
        checkIsNumber(e, onlyIf) {
            let proceed_check = true;
            if (typeof onlyIf !== 'undefined') {
                if (!onlyIf) { // only if fails
                    proceed_check = false;
                }
            }
            if (proceed_check && this.invalidChars.includes(e.key)) {
                e.preventDefault();
            }
        },
    }
}
